import { APIGeocode } from './api_geocode';

export class Waypoint {
    constructor(lon, lat, name) {
        this.lon = lon;
        this.lat = lat;
        this.name = name;
        this.updating = false;
        this.onChangedListener = [];
        this.id = Waypoint.counter++;
    }

    update(lon, lat, name="") {
        this.lon = lon;
        this.lat = lat;
        if (name === "") {
            // do a reverse geocode
            this.updating = true;
            APIGeocode.reverseGeocode(lon, lat)
            .then((data) => {
                this.update(lon, lat, data.loc_name);
            })
            .catch(() => {})
            .finally(() => {
                this.updating = false;
            })
        } else {
            this.name = name;
        }
        for (const cb of this.onChangedListener) {
            cb();
        }
    }

    addListener(cb) {
        this.onChangedListener.push(cb);
    }

    toString() {
        return this.lon + ", " + this.lat;
    }

    isValid() {
        return this.lon != 0 && this.lat != 0;
    }
}

Waypoint.counter = 0;  // static var used to generate unique ID (lol)